/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  FormEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { addDays, format, parseISO } from 'date-fns';
import { FiSearch } from 'react-icons/fi';
import { MdFilterList } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import { useHistory } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

import { IconPieChartSvg } from '~/assets/icons';
import { ButtonAdd, Layout } from '~/components';
import { useAuth } from '~/hooks/auth';
import api from '~/services/api';

import CardStudent from './CardStudent';
import FilterModal from './FilterModal';
import { StudentProps } from './interface';

import {
  AlertContainer,
  ButtonExportReport,
  Container,
  ContentRight,
  Header,
  InputContainer,
  ListStudents,
  PaginateContainer,
  RadioOption,
} from './styles';

type Filter = {
  by: string;
  from: string;
};

const Students = () => {
  const { push } = useHistory();
  const { user } = useAuth();
  const searchRef = useRef<HTMLInputElement>(null);

  const [students, setStudents] = useState<StudentProps[]>([]);
  const [studentsBkp, setStudentsBkp] = useState<StudentProps[]>([]);

  const [by, setBy] = useState('');
  const [from, setFrom] = useState('');

  const [page = 1, setPage] = useState<number>();
  const [lastPage = 1, setLastPage] = useState<number>();
  const [loading, setLoading] = useState(false);

  const [modalFilterIsOpen, setModalFilterIsOpen] = useState(false);

  const [status, setStatus] = useState('');

  const loadStudents = useCallback(async () => {
    setLoading((prevState) => !prevState);

    const response = await api.get(
      `/professionals/${user.professional?.id}/students`,
    );

    const responseFormatted = response.data.data.map((item: StudentProps) => ({
      ...item,
      created_at: format(parseISO(item.created_at), "dd'/'MM'/'yyyy"),
      student: {
        ...item.student,
        birth_date: format(parseISO(item.student.birth_date), "dd'/'MM'/'yyyy"),
      },
    }));

    setStudents(responseFormatted);
    setStudentsBkp(responseFormatted);
    setPage(response.data.page);
    setLastPage(response.data.lastPage);

    setLoading((prevState) => !prevState);
  }, [user]);

  // ? Modal chama aqui
  const loadFilteredStudents = useCallback(async () => {
    setLoading((prevState) => !prevState);

    const response = await api.get(
      `/professionals/${user.professional?.id}/students`,
      {
        params: {
          status,
          signup_date_init: by,
          signup_date_end: from,
        },
      },
    );

    const responseFormatted = response.data.data.map((item: StudentProps) => ({
      ...item,
      created_at: format(parseISO(item.created_at), "dd'/'MM'/'yyyy"),
      student: {
        ...item.student,
        birth_date: format(
          addDays(parseISO(item.student.birth_date), 1),
          "dd'/'MM'/'yyyy",
        ),
      },
    }));

    setStudents(responseFormatted);
    setStudentsBkp(responseFormatted);
    setPage(response.data.page);
    setLastPage(response.data.lastPage);

    setLoading((prevState) => !prevState);
    setModalFilterIsOpen((prevState) => !prevState);
  }, [user, status, by, from]);

  const handlePageClick = useCallback(
    async (data) => {
      setLoading((prevState) => !prevState);

      const pageSelected = data.selected + 1;

      const response = await api.get(
        `/professionals/${user.professional?.id}/students`,
        { params: { page: pageSelected } },
      );

      setStudents(response.data.data);
      setPage(response.data.page);
      setLastPage(response.data.lastPage);
      setLoading((prevState) => !prevState);
    },
    [user.professional?.id],
  );

  const handleSearchStudent = useCallback(
    async (e: FormEvent) => {
      setLoading((prevState) => !prevState);

      e.preventDefault();

      const searchText = searchRef.current?.value || '';

      const aim = studentsBkp.filter((content) => {
        const studentStatusFormated =
          content.student.status === 'active' ? 'ativo' : 'inativo';

        return (
          content.student.cpf.includes(searchText) ||
          content.name.toLowerCase().includes(searchText.toLowerCase()) ||
          studentStatusFormated.toLowerCase().includes(searchText.toLowerCase())
        );
      });

      setStudents(aim);

      setLoading((prevState) => !prevState);
    },
    [students, studentsBkp],
  );

  const handleDeleteStudent = useCallback(async (id: number) => {
    await api.delete(`/students/${id}`);

    loadStudents();
  }, []);

  useEffect(() => {
    loadStudents();
  }, [loadStudents]);

  const cardsStudentsMemo = useMemo(
    () =>
      students.map((student) => (
        <CardStudent
          key={student.id}
          user={student}
          handleDeleteStudent={() => handleDeleteStudent(student.student.id)}
        />
      )),
    [handleDeleteStudent, students],
  );

  const exportReportList = useMemo(() => {
    return [
      { label: 'Sim', value: true },
      { label: 'Não', value: false },
    ];
  }, []);

  const statusList = useMemo(() => {
    return [
      { label: 'Ativo', value: 'active' },
      { label: 'Inativo', value: 'inactive' },
      { label: 'Ambos', value: '' },
    ];
  }, []);

  const reportUrl = useMemo(() => {
    return `${process.env.REACT_APP_API_URL}/reports/${user.professional.id}/crm-students?type=excel`;
  }, [user]);

  const statusFilterOptions = useMemo(
    () =>
      statusList.map((item) => (
        <RadioOption
          key={item.label}
          type="button"
          isSelected={status === item.value}
          onClick={() => setStatus(item.value)}
        >
          <div className="radio">
            <div className="filled" />
          </div>

          <p>{item.label}</p>
        </RadioOption>
      )),
    [status, statusList],
  );

  return (
    <Layout title="Meus alunos">
      <Container>
        <Header>
          <ButtonAdd onClick={() => push('/professional/students/register')}>
            Novo aluno
          </ButtonAdd>

          <ContentRight>
            <InputContainer>
              <form onSubmit={handleSearchStudent}>
                <FiSearch size={30} color="#000" />

                <input
                  type="text"
                  placeholder="Buscar por nome ou CPF"
                  name="search"
                  id="search"
                  ref={searchRef}
                  onChange={handleSearchStudent}
                />

                <MdFilterList
                  size={30}
                  color="#000"
                  onClick={() => setModalFilterIsOpen(true)}
                />
              </form>
            </InputContainer>

            <ButtonExportReport href={reportUrl} target="_blank">
              <IconPieChartSvg />

              <div>
                <p>Exportar relatório</p>
              </div>
            </ButtonExportReport>
          </ContentRight>
        </Header>

        {loading ? (
          <AlertContainer>
            <MoonLoader size={30} color="#FFDF22" />
          </AlertContainer>
        ) : (
          <ListStudents>{cardsStudentsMemo}</ListStudents>
        )}

        {students?.length === 0 && loading === false ? (
          <AlertContainer>
            <h1>Nenhum usuário encontrado</h1>
          </AlertContainer>
        ) : null}

        <PaginateContainer>
          <ReactPaginate
            nextLabel="Próxima"
            pageCount={lastPage}
            marginPagesDisplayed={0}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName="pagination"
            activeClassName="active"
          />
        </PaginateContainer>

        <FilterModal
          loading={loading}
          modalVisible={modalFilterIsOpen}
          setModalVisible={setModalFilterIsOpen}
          statusFilterOptions={statusFilterOptions}
          by={by}
          setBy={setBy}
          from={from}
          setFrom={setFrom}
          setStatus={setStatus}
          loadFilteredStudents={loadFilteredStudents}
        />
      </Container>
    </Layout>
  );
};

export default Students;
